import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import Message from '../Message/Message';
import '../../styles/conversation.scss';
import $ from 'jquery';
const ReactCSSTransitionGroup = require('react-addons-css-transition-group');
import {withExperiments} from 'wix-experiments-react';
import _ from 'lodash';

class Conversation extends React.Component {

  scrollToBottom() {
    const newList = $('.message');
    const lastMsg = newList.length && newList.last()[0];
    if (lastMsg) {
      lastMsg.scrollIntoView();
    }
  }

  /* eslint-disable */
  stopScrollPropagation() {
    $(document).on('DOMMouseScroll mousewheel', '.conversation', function (ev) {
      var $this = $(this),
        scrollTop = this.scrollTop,
        scrollHeight = this.scrollHeight,
        height = $this.innerHeight(),
        delta = (ev.type == 'DOMMouseScroll' ?
        ev.originalEvent.detail * -40 :
          ev.originalEvent.wheelDelta),
        up = delta > 0;

      var prevent = function () {
        ev.stopPropagation();
        ev.preventDefault();
        ev.returnValue = false;
        return false;
      };

      if (!up && -delta > scrollHeight - height - scrollTop) {
        // Scrolling down, but this will take us past the bottom.
        $this.scrollTop(scrollHeight);
        return prevent();
      } else if (up && delta > scrollTop) {
        // Scrolling up, but this will take us past the top.
        $this.scrollTop(0);
        return prevent();
      }
    });
  }
  /* eslint-enable */

  componentDidMount() {
    this.stopScrollPropagation();
    this.scrollToBottom();
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  isConsecutiveMessages(msg, nextMsg) {
    return nextMsg && msg.direction === nextMsg.direction;
  }

  render() {
    const {messages, error, chatSettings} = this.props;
    const shouldShowAvatar = !(_.get(chatSettings, 'design.selectedImageOption') === '1');
    if (messages.length === 0) {
      return (
        <div className="empty-conversation">
          <span className="icon"/>
          {!error ? <div>{_.get(chatSettings, 'texts.onlineMessage')}</div> : null}
        </div>
      );
    } else {
      return (
        <ReactCSSTransitionGroup
          className={`conversation ${shouldShowAvatar ? 'show-avatar' : 'hide-avatar'}`}
          transitionName="example"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={300}
          >
          {messages.map((message, index) =>
            <Message message={message} key={index} isLastInSequence={!this.isConsecutiveMessages(message, index < messages.length - 1 ? messages[index + 1] : null)}/>
          )}
        </ReactCSSTransitionGroup>
      );
    }
  }
}

Conversation.propTypes = {
  messages: PropTypes.array,
  error: PropTypes.bool,
  chatSettings: PropTypes.object
};

function mapStateToProps(state) {
  return {
    chatSettings: state.chatSettings
  };
}

export default withExperiments(connect(mapStateToProps)(Conversation));



// WEBPACK FOOTER //
// ./chat-app/components/Conversation/Conversation.js